export const languages = ["en", "es"];


// WEBPACK FOOTER //
// ./src/translations/Languages.js